import type { ChannelMiniEntity } from '@/features/channel/domain/entities/ChannelMiniEntity'
import type { RateType } from '../enums/RateType'
import type { OrderRateReasonTranslationEntity } from './OrderRateReasonTranslationEntity'

export class CreateUpdateOrderRateReasonEntity {
  translations?: OrderRateReasonTranslationEntity[]
  channel?: ChannelMiniEntity
  rateType?: RateType
  minRate?: number
  maxRate?: number
}
